import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigUtils } from '../utils/configUtils';
import { RepresentanteServices } from './representanteServices';

@Injectable()
export class VisitaServices{
  static cacheVisita:any={};
  static currentRuta:any={};
  static filtroReporte:any={};
  
  constructor(public http: HttpClient, private representanteServices:RepresentanteServices){}
  
  getVisitas(filtro){
    let url = ConfigUtils.getUrlFromEndPointName('visitador');
    url+='/getVisitasByIdCicloYEmail';
    console.log(url);
    console.log(filtro);
    return this.http.post<any>(url,filtro);
  }
  getLineasVisita(visita){
    if(!visita || !visita.tipo || !visita.idVisita)
      return null
    let url = ConfigUtils.getUrlFromEndPointName('visitador');
    url+='/getLineasVisitaById/'+visita.idVisita+'/'+visita.tipo;
    console.log(url);
    return this.http.get<any>(url);
  }
}



